/**
 * Supported media / streaming types for the next-gen engine.
 */
export const MediaType = Object.freeze({
  MP4: "mp4",
  HLS: "hls",
  YOUTUBE: "youtube",
  VIMEO: "vimeo",
  UNKNOWN: "unknown",
});

/**
 * @param {string} url
 * @returns {string}
 */
export function detectMediaType(url) {
  if (!url || typeof url !== "string") {
    return MediaType.UNKNOWN;
  }
  var lower = url.split("?")[0].toLowerCase();
  var query = url.indexOf("?") !== -1 ? url.slice(url.indexOf("?")).toLowerCase() : "";

  if (
    lower.indexOf("youtube.com") !== -1 ||
    lower.indexOf("youtu.be") !== -1 ||
    lower.indexOf("youtube-nocookie.com") !== -1
  ) {
    return MediaType.YOUTUBE;
  }
  if (lower.indexOf("vimeo.com") !== -1) {
    return MediaType.VIMEO;
  }

  if (lower.indexOf(".m3u8") !== -1) {
    return MediaType.HLS;
  }
  if (
    lower.indexOf(".mp4") !== -1 ||
    lower.indexOf(".webm") !== -1 ||
    lower.indexOf(".ogg") !== -1
  ) {
    return MediaType.MP4;
  }
  // Heuristic: many CDNs omit extensions for HLS manifests
  if (
    lower.indexOf("m3u8") !== -1 ||
    lower.indexOf("/hls/") !== -1 ||
    lower.indexOf("application/x-mpegurl") !== -1 ||
    lower.indexOf("application/vnd.apple.mpegurl") !== -1 ||
    lower.indexOf("/playlist") !== -1 ||
    query.indexOf("format=m3u8") !== -1 ||
    query.indexOf("type=m3u8") !== -1 ||
    query.indexOf("ext=m3u8") !== -1
  ) {
    return MediaType.HLS;
  }
  return MediaType.UNKNOWN;
}

/**
 * Native HLS (Safari / iOS). Chrome/Firefox need an ABR adapter (future hls.js).
 * @returns {boolean}
 */
export function canPlayNativeHls() {
  try {
    var video = document.createElement("video");
    return (
      video.canPlayType("application/vnd.apple.mpegurl") !== "" ||
      video.canPlayType("application/x-mpegURL") !== ""
    );
  } catch (e) {
    return false;
  }
}

export default MediaType;
